"use client";
import type { ReactElement, RefObject } from "react";
import type { MotionValue } from "framer-motion";
import { motion } from "framer-motion";
import { Ccontainer } from "@/components/ui/Ccontainer";
import { Cscrollable } from "@/components/ui/Cscrollable";
import { RadiusSize } from "@/theme";
import { CWITNESS_OVERFLOW_HIDDEN, CWITNESS_PARALLAX_TEXT_BLOCKS, CWITNESS_PARALLAX_TEXT_SCROLLABLE_FADE_SIZE, CWITNESS_PARALLAX_TEXT_SCROLLABLE_TOP_SPACING, CWITNESS_SCROLL_DIRECTION_VERTICAL, } from "./constants";
import { CwitnessParallaxTextBlock } from "./CwitnessParallaxTextBlock";
import { buildParallaxCardStyle, buildParallaxContentStyle, buildParallaxScrollableStyle, } from "./styles";
import type { ParallaxTextSpacingValue } from "./types";
const MOBILE_VALUE = "mobile";
const DESKTOP_VALUE = "desktop";
interface CwitnessParallaxTextCardProps {
    contentRef: RefObject<HTMLDivElement | null>;
    isMobile: boolean;
    parallaxTextSize: number;
    scrollRef: RefObject<HTMLDivElement | null>;
    textBottomSpacing: ParallaxTextSpacingValue;
    textTopSpacing: ParallaxTextSpacingValue;
    textY: MotionValue<number>;
}
export function CwitnessParallaxTextCard({ contentRef, isMobile, parallaxTextSize, scrollRef, textBottomSpacing, textTopSpacing, textY, }: CwitnessParallaxTextCardProps): ReactElement {
    const parallaxCardStyle = buildParallaxCardStyle({ isMobile });
    const parallaxContentStyle = buildParallaxContentStyle({
        textBottomSpacing,
        textTopSpacing,
        textY,
    });
    const parallaxScrollableStyle = buildParallaxScrollableStyle({ isMobile });
    return (
      <Ccontainer radius={RadiusSize.Large} backdropBlur={isMobile ? 0 : 5} style={{
            ...parallaxCardStyle,
            ...(isMobile ? { borderRadius: "4rem" } : {}),
            backgroundImage: "linear-gradient(180deg, rgba(102, 254, 193, 0.08) 0%, transparent 50%)",
            boxShadow: isMobile
                ? "none"
                : "rgba(255, 255, 255, 0.15) 0px 0px 7px 0px inset",
            padding: "0",
        }} overflow={CWITNESS_OVERFLOW_HIDDEN}>
        <Cscrollable dataElScope="Cwitness/CwitnessParallaxTextCard" scrollRef={scrollRef} direction={CWITNESS_SCROLL_DIRECTION_VERTICAL} fadeSize={CWITNESS_PARALLAX_TEXT_SCROLLABLE_FADE_SIZE} firstItemSpacing={CWITNESS_PARALLAX_TEXT_SCROLLABLE_TOP_SPACING} style={parallaxScrollableStyle}>
          <motion.div ref={contentRef} style={parallaxContentStyle}>
            {CWITNESS_PARALLAX_TEXT_BLOCKS.map((block) => {
            return (<CwitnessParallaxTextBlock key={block.id} text={block.text} size={parallaxTextSize} isAccent={block.isAccent}/>);
        })}
          </motion.div>
        </Cscrollable>
      </Ccontainer>
    );
}
